/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { RemoteAccessOrganizationSites } from '../../models/remote-access-organization-sites';

export interface GetAdministrationRemoteAccesses$Params {
  organizationSiteKey: KeyType;
}

export function getAdministrationRemoteAccesses(http: HttpClient, rootUrl: string, params: GetAdministrationRemoteAccesses$Params, context?: HttpContext): Observable<StrictHttpResponse<RemoteAccessOrganizationSites>> {
  const rb = new RequestBuilder(rootUrl, getAdministrationRemoteAccesses.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RemoteAccessOrganizationSites>;
    })
  );
}

getAdministrationRemoteAccesses.PATH = '/administration/organization-sites/{organizationSiteKey}/remote-accesses';
